/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AcceptancesControllerGetAcceptancesQueryResponse, AcceptancesControllerGetAcceptancesPathParams, AcceptancesControllerGetAcceptances401 } from "../../models/acceptancesController/AcceptancesControllerGetAcceptances";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { acceptancesControllerGetAcceptances } from "../../clients/acceptancesService/acceptancesControllerGetAcceptances";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const acceptancesControllerGetAcceptancesQueryKey = (principalId: AcceptancesControllerGetAcceptancesPathParams["principalId"], principalType: AcceptancesControllerGetAcceptancesPathParams["principalType"]) => [{
  url: '/api/v1/acceptances/:principalType/:principalId',
  params: {
    principalType: principalType,
    principalId: principalId
  }
}] as const;
export type AcceptancesControllerGetAcceptancesQueryKey = ReturnType<typeof acceptancesControllerGetAcceptancesQueryKey>;
export function acceptancesControllerGetAcceptancesQueryOptions(principalId: AcceptancesControllerGetAcceptancesPathParams["principalId"], principalType: AcceptancesControllerGetAcceptancesPathParams["principalType"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = acceptancesControllerGetAcceptancesQueryKey(principalId, principalType);
  return queryOptions<AcceptancesControllerGetAcceptancesQueryResponse, ResponseErrorConfig<AcceptancesControllerGetAcceptances401>, AcceptancesControllerGetAcceptancesQueryResponse, typeof queryKey>({
    enabled: !!(principalId && principalType),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return acceptancesControllerGetAcceptances(principalId, principalType, config);
    }
  });
}

/**
 * @summary Get all acceptances for a principal
 * {@link /api/v1/acceptances/:principalType/:principalId}
 */
export function useAcceptancesControllerGetAcceptances<TData = AcceptancesControllerGetAcceptancesQueryResponse, TQueryData = AcceptancesControllerGetAcceptancesQueryResponse, TQueryKey extends QueryKey = AcceptancesControllerGetAcceptancesQueryKey>(principalId: AcceptancesControllerGetAcceptancesPathParams["principalId"], principalType: AcceptancesControllerGetAcceptancesPathParams["principalType"], options: {
  query?: Partial<QueryObserverOptions<AcceptancesControllerGetAcceptancesQueryResponse, ResponseErrorConfig<AcceptancesControllerGetAcceptances401>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? acceptancesControllerGetAcceptancesQueryKey(principalId, principalType);
  const query = useQuery({
    ...acceptancesControllerGetAcceptancesQueryOptions(principalId, principalType, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AcceptancesControllerGetAcceptances401>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}